module.exports = __webpack_public_path__ + "img/number-black-5.ab80fdc0.png";